// ABOUTME: Books coaching through the Nylas slot picker in place of FreeBusy for a participant
// ABOUTME: The caller renders its own trigger; follow-ups run once the modal closes after booking
import { BookingResult } from '@execonline-inc/slot-picker.private';
import { observer } from 'mobx-react';
import { ReactNode, useRef, useState } from 'react';
import { currentUserStore } from '../../CurrentUser/Store';
import { Link } from '../../Resource/Types';
import CoachingSchedulerModal from './CoachingSchedulerModal';

interface Props {
  schedulerLink: Link;
  participantEmail: string;
  // Runs after the modal closes with the sessions booked, so a reload behind it cannot unmount
  // the confirmation.
  onBooked: (booked: BookingResult[]) => void;
  children: (open: () => void) => ReactNode;
}

const CoachingScheduler = ({ schedulerLink, participantEmail, onBooked, children }: Props) => {
  const [open, setOpen] = useState(false);
  const booked = useRef<BookingResult[]>([]);
  const locale = currentUserStore.preferredLanguage.getOrElseValue('en');

  const close = () => {
    setOpen(false);
    if (booked.current.length > 0) {
      onBooked(booked.current);
      booked.current = [];
    }
  };

  return (
    <>
      {children(() => {
        setOpen(true);
      })}
      {open ? (
        <CoachingSchedulerModal
          schedulerHref={schedulerLink.href}
          participantEmail={participantEmail}
          locale={locale}
          onBooked={(sessions) => {
            // Picking again after a partial booking can book more in the same modal.
            booked.current = [...booked.current, ...sessions];
          }}
          onClose={close}
        />
      ) : (
        <></>
      )}
    </>
  );
};

export default observer(CoachingScheduler);
